/**
 * @description update data attribute for no adyen payment methods which is used in adyenCheckout.js to place order
 */
function updatePaymentOptions() {
    const $paymentMethodsWrapper = $(".core-methods");
    const $selectedPaymentOptions = $("#selectedPaymentOption");

    $(document).on("change", "input[type=radio][name=brandCode]", function () {
        const $aditionalFields = $(".additionalFields");

        $selectedPaymentOptions.val(getSelectedValue($(this)));

        if ($(this).hasClass("noadyen-payment")) {
            $paymentMethodsWrapper.attr("data-payment-method-name", "otherPayment");
            $aditionalFields.hide();
        } else {
            $paymentMethodsWrapper.attr("data-payment-method-name", "");
        }
    });
}

/**
 * @description sort payment options based on values set in BM for each payment method
 */
function sortPaymentOptions() {
    const $adyenWrapper = $(".adyen-wrapper");
    const $paymentOptions = $(".payment-option-wrapper");
    let breakpoint = $(window).width() > 768 ? "lg" : "sm";

    if ($paymentOptions.length) {
        $paymentOptions.each(function () {
            let $this = $(this);
            let $paymentOptionWrapper = $this.hasClass("adyen") ? $adyenWrapper : $this;
            let position = $this.data("position-" + breakpoint);

            if (position) {
                $paymentOptionWrapper.css("order", position);
            }
        });
    }
}

/**
 * @description returns value for selected payment method
 * @param {Object} input - payment method input object
 * @returns {String} - value of selected payment method
 */
function getSelectedValue(input) {
    const adyenPaymentMethods = ["scheme", "klarna", "klarna_paynow"];
    let selectedPaymentValue;

    if (adyenPaymentMethods.includes(input.val()) || input.val().includes("storedCard")) {
        selectedPaymentValue = input.parents("#adyen-component-content").find("input[name='dwfrm_billing_paymentMethod']").val();
    } else {
        selectedPaymentValue = input.val();
    }

    return selectedPaymentValue;
}

module.exports = {
    updatePaymentOptions: updatePaymentOptions,
    sortPaymentOptions: sortPaymentOptions,
    getSelectedValue: getSelectedValue
};
